<template>
  <div class="Profil">
    <div class="d-none d-sm-block">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">Profil</li>
      </ol>
    </nav>
  </div>
    <Profil v-if="user!=null" ref="Profil" @userchanged="userChanged" :user="user" :profil="true"/>
  </div>
</template>

<script>
import Profil from './Profil.vue'

export default {
  name: 'Benutzer',
  components: {
    Profil
  },
  methods: {
    userChanged: function (user) {
      console.log('set user')
      if (user != null) {
        this.user = user
      }
    }
  },
  data () {
    return {
      user: this.$store.state.auth.user
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/WrappedProfil.vue